import { IOrganization } from "@/api";
import { NewClauseChecklistDialog } from "@/components/admin/dialogs/clause-checklists/NewClauseChecklistDialog";
import { Button } from "@/components/shared/buttons/Button";
import { useDialogs } from "@toolpad/core";

interface IProps {
    /**
     * The organization to create a new checklist for
     */
    organization: IOrganization;
}

/**
 * A button to create a new checklist for an organization
 */
export const CreateNewChecklistsButton = ({ organization }: IProps) => {
    const dialogs = useDialogs();

    const handleClick = () => {
        dialogs.open(NewClauseChecklistDialog, {
            organization,
        });
    };

    return (
        <Button
            variant="contained"
            color="secondary"
            sx={{ borderRadius: 29 }}
            disableElevation
            onClick={handleClick}
        >
            Create New Checklist
        </Button>
    );
};
